import * as React from 'react'
import { amphtml } from '../../google-amp/react_amp'
import { InnerAdProps } from '../../google-amp/components/AmpAdProps'
import { getAdSize, pickFirstSizeMapping } from '@news-mono/web-common'

interface InnerProps {
    width: number
    height: number
    type: 'widespace'
    layout?: 'responsive' | 'fixed'
}
const AmpBigMobileAdElement = amphtml<InnerProps>('ad')

export type AmpBigMobileAdProps = InnerAdProps

export const AmpBigMobileAd: React.FC<AmpBigMobileAdProps> = (
    props: AmpBigMobileAdProps,
) => {
    const adUnit = props.adState.unitLookup(props.unitId, 0)
    if (!adUnit) {
        return null
    }

    const { sizeMapping } = adUnit
    const adSize = getAdSize(sizeMapping, 0)
    const firstSize = pickFirstSizeMapping(adSize)
    if (!firstSize) {
        return null
    }

    const [width, height] = firstSize

    const ad = (
        <AmpBigMobileAdElement
            width={width}
            height={height}
            layout={props.layout}
            type="widespace"
            data-sid="e2446a32-1873-4dc4-9b06-4d47f1a04fc3"
        />
    )

    return ad
}
